import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DynamicConfigProviderService } from '../services/dynamic-config-provider.service';

interface MessageData<T = any> {
  type: '' | '';
  content: { [name: string]: any } | T;
}

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private ws$: WebSocket;

  private handlers: Map<string, Subject<any>> = new Map<string, Subject<any>>();

  public constructor(private config: DynamicConfigProviderService) {
    this.reconnect();
  }

  public reconnect() {
    console.log('Attempting establish ws connection');
    const url = this.config.wsUrl;

    this.ws$ = new WebSocket(url);
    this.ws$.onclose = this.closeHandler.bind(this);
    this.ws$.onmessage = this.messageHandler.bind(this);
  }

  public getChannel<T>(channel: string): Observable<T> {
    if (!this.handlers.has(channel)) {
      this.handlers.set(channel, new Subject<any>());
    }

    return this.handlers.get(channel).asObservable();
  }

  private closeHandler() {
    console.log('Connection closed. Trying to reconnect.');
    this.reconnect();
  }

  private messageHandler(message: MessageEvent) {
    if (!message || !message.data) {
      return;
    }

    const data = JSON.parse(message.data) as MessageData;

    if (!data) {
      return;
    }

    if (this.handlers.has(data.type)) {
      this.handlers.get(data.type).next(data.content);
    }
  }
}
